import React from "react";
import Storia from "../components/site/Storia";

export default function StoriaPage() {
  return (
    <div className="pt-20">
      <Storia />
    </div>
  );
}
